export const blockIconsTextformattingHistoryEduNew = (
	<span className='material-symbols-outlined'>history_edu</span>
);
